import { render } from "./MenuVoice.vue?vue&type=template&id=d363262c"
import script from "./MenuVoice.vue?vue&type=script&lang=js"
export * from "./MenuVoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__